import { viewWithIdSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const getInventoryLevelLedgerView = {
  name: "getInventoryLevelLedgerView" as const,
  input: z.object({}),
  output: z.object({ view: viewWithIdSchemas["inventory-level-ledger"] }),
};
